import './src/styles/global.css'
export const onServiceWorkerUpdateReady = () => {
  window.location.reload()
}
